export const MESSAGES = {
    SHOW_PREVIEW: 'message.showPreview',
    PREVIEW_HIDDEN: 'message.previewHidden',
    PREVIEW_SHOWN: 'message.previewShown',
    RECEIVER_AVAILABLE: 'message.receiverAvailable',
    EMBED_AVAILABLE: 'message.embedAvailable',
    OVERRIDES_AVAILABLE: 'message.overridesAvailable',
    SET_STATE: 'message.setState',
    SET_SOURCE: 'message.setSource',
    OUTSIDE_PLAYER_CLICK: 'message.outsidePlayerClick',
    ESCAPE_CLICK: 'message.escapeClick'
};